import React from 'react';

import useIsRootPath from '../../../hooks/useIsRootPath';
import Logo from '../Logo/Logo';

const Header = ({ isSplash, topNav }: HeaderTypes) => {
	// The nav (and its controls) only exist on the home page.
	const isRootPath = useIsRootPath();

	return (
		<>
			<header>
				<Logo isSplash={isSplash} />
			</header>

			{isRootPath && topNav}
		</>
	);
};

type HeaderTypes = {
	isSplash: boolean;
	topNav: React.ReactNode;
};

export default Header;
